export default () => {
  const sliders = document.querySelectorAll('.js-item-slider');
  if (! sliders) return

  [...sliders].forEach(slider => {
    const slides = slider.querySelectorAll('.js-item-slide');
    const firstSlide = slider.querySelector('.js-item-slide');
    const slidesCount = slider.querySelectorAll('.js-item-slide').length;
    if (slides.length == 0) return;
    let slideWidth = firstSlide.offsetWidth;
    let pos = 0;

    // Recalculate on resize
    window.addEventListener('resize', () => {
      slideWidth = firstSlide.offsetWidth;
      pos = 0;
      setTransform();
      clearInterval(autoSlider);
    });

    const autoSlider = setInterval(() => {
      goNext();
    }, 5000);

    // Helper functions
    function setTransform() {
      slider.style['transform'] = 'translate3d(' + -pos * slideWidth + 'px,0,0)';
    }

    function goNext() {
      if (pos == slidesCount - 1) {
        pos = 0;
        setTransform();
      } else if (pos < slidesCount - 1) {
        pos++;
        setTransform();
      }
    }
  });
};


// WEBPACK FOOTER //
// ./src/js/modules/ItemSlider.js